import { env } from 'config/env';

type MsalCacheLocation = 'localStorage' | 'memoryStorage';

// Public page crash if user denies cookies/ localStorage access
// MSAL is an external library that cannot use your safeLocalStorage wrapper.
// MSAL only accepts its own cache storage options (localStorage, sessionStorage, memoryStorage).
// therefore cant we use src\utils\safeLocalStorage.ts like the rest of app
const resolveMsalCacheLocation = (): MsalCacheLocation => {
    try {
        const testKey = '__msal_storage_probe__';
        window.localStorage.setItem(testKey, '1');
        window.localStorage.removeItem(testKey);
        return 'localStorage';
    } catch {
        // localStorage can be blocked when users reject cookies/tracking in some browsers
        return 'memoryStorage';
    }
};

// MSAL configuration for Entra ID login
export const msalConfig = {
    enabled: env.loginEntraIdEnabled,
    auth: {
        clientId: env.entraClientId || '',
        authority: `https://login.microsoftonline.com/${env.tenantId || ''}`,
        redirectUri: window.location.origin + '/auth-redirect',
    },
    cache: {
        cacheLocation: resolveMsalCacheLocation(),
        storeAuthStateInCookie: false,
    },
};
